<template>
  <div>
     <!-- Footer Area -->
    <footer class="footer_area fa_2">
        <div class="container">
            <div class="footer_inner row">
                <div class="col-xl-4 col-md-5 col-sm-7 footer_logo wow fadeIn">
                    <a href="/"><img src="images/logo-splash.png" alt="" style="width: 70%"></a>
                    <p>Credimóvil © 2024. Developed by GPI ©.</p>

                    <ul class="footer_social">
                        <li><a href="https://www.facebook.com/credimoviI" target="_blank"></a></li>
                    </ul>
                </div>
                <div class="footer_widget col-xl-4 col-md-5 col-sm-5 wow fadeIn" data-wow-delay="0.2s">
                    <h4>Nosotros</h4>
                    <ul class="footer_nav">
                        <li><a href="/quote-credit">Cotiza tu crédito</a></li>
                        <li><a href="/credit-request">Solicita tu crédito</a></li>
                        <li><a href="/business-partners">Socios comerciales</a></li>
                        <li><a href="/quote-insurance">Cotiza tu seguro</a></li>
                        <li><a href="/buy-car">Comparador de autos</a></li>
                    </ul>
                </div>
                <div class="footer_widget col-xl-4 col-md-5 col-sm-5 wow fadeIn" data-wow-delay="0.6s">
                    <h4>¿Necesitas ayuda?</h4>
                    <ul class="footer_nav">
                        <li><a href="/faq">FAQ</a></li>
                        <li><a href="/contact">Contacto</a></li>
                        <li><a href="/terms-conditions">Términos y condiciones</a></li>
                        <li><a href="/privacy-notice">Aviso de privacidad</a></li>
                        <li><a href="https://forms.clickup.com/f/81yz9-147/VBLB3AJRLBM926TUPL" target="_blank">Línea de denuncia</a></li>
                    </ul>
                </div>
                <div class="col-12 text-center text-white m-0 p-0">
                        <a href="https://www.credimovil.mx/index.html" target="_blank">By Credimovil</a>
                </div>
            </div>
        </div>
    </footer>
    <!-- End Footer Area -->

    <!-- Scroll Top Button -->
    <button class="scroll-top">
        <i class="fa fa-angle-double-up"></i>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<style lang="scss">

footer{
    z-index: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue